import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import Terms from "@/pages/Terms";
export const Route = createFileRoute("/terms")({ head: ({match}) => pageHead(match.pathname), component: () => (<Terms />) });
